import type { TProjectSettingsTag } from '@cascade/api-client/project-settings';
import type { TTagGroup } from '@cascade/react/projects';
import type { TSetEmailTagItem } from '@cascade/api-client/tagging';

export const toTagOptions = (tag: TProjectSettingsTag) =>
  Object.entries(tag.values)
    .map(([value, label]) => ({ label, value }))
    .sort((left, right) => left.label.localeCompare(right.label));

const toDefaultTagValue = (tag: TProjectSettingsTag): string => {
  if (tag.value) {
    return tag.value;
  }

  const optionValues = Object.keys(tag.values);

  return optionValues.length === 1 ? optionValues[0] : '';
};

export const toDefaultTagValues = (tags: TProjectSettingsTag[]): TTagGroup =>
  Object.fromEntries(tags.map((tag) => [tag.key, toDefaultTagValue(tag)]));

export const toTagItems = (
  tags: TProjectSettingsTag[],
  values: TTagGroup,
): TSetEmailTagItem[] =>
  tags
    .filter((tag) => Boolean(values[tag.key]))
    .map((tag) => ({ key: tag.key, value: values[tag.key] }));
